import { get, post } from './groupAjax'

const api = {
  // 购买详情页
  getProductDetail: p => get('/group-buying/buy-detail/get-product-detail', p, true),
  // 生成团购订单
  orderAdd: p => post('/group-buying/pay/order-add', p, true),
  // 发送验证码
  sendVcode: p => post('/parent/auth/send-h5-vcode', p, true),
  //团购验证码登录
  loginGroupBuying: p => post('/parent/auth/login-group-buying', p, true),
  //注册家长同手机号学生并绑定
  registerStudentAndBind: p => post('/parent/auth/register-student-and-bind', p, true),
  //获取微信用户信息
  getUserInfo: p => post('/new-parent/wechat/get-user-info', p, 'course'),
  //微信分享
  wxShare: p => post('/new-parent/wechat/wx-share', p, false),
  //课程列表
  myGroupBuying: p => get('/group-buying/buy-detail/my-group-buying', p),
}
export default api